/**
 * Sales / support WhatsApp helper.
 *
 * Centralised so we can swap the number in one place if it changes.
 * India number (+91). If it ever needs to be per-region, export as a map.
 */
export const SALES_WHATSAPP_NUMBER = "917024045401"; // +91 70240 45401 — HisabX sales

/** Build a wa.me deep-link with an optional pre-filled message. */
export function buildWhatsAppLink(message, number = SALES_WHATSAPP_NUMBER) {
  const url = `https://wa.me/${number}`;
  if (!message) return url;
  return `${url}?text=${encodeURIComponent(message)}`;
}

/** Pre-composed pitches used across the app. */
export const SALES_PITCHES = {
  /* Public — used from /login hero + /pricing hero pill */
  trialSignup: () =>
    `Hi HisabX team! I saw your app and I'd like to start the 6-month free trial for my petrol pump. Can you help me set it up?`,

  /* Public — used from /pricing enterprise card */
  enterpriseInquiry: (pumpCount) =>
    `Hi HisabX team! I run ${pumpCount || "multiple"} petrol pump outlets and would like to discuss your Enterprise plan.`,

  /* Admin console — outbound sales for a captured enterprise lead */
  leadFollowUp: ({ name, pumpCount }) =>
    `Hi ${name || "there"}, this is from HisabX. Thanks for your interest in our Enterprise plan for ${
      pumpCount ? `${pumpCount} pump${pumpCount > 1 ? "s" : ""}` : "your pumps"
    } — do you have 10 minutes for a quick call today?`,

  /* Reserved for future outreach flows */
  generic: () => `Hi HisabX team!`,
};
